import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const FontFileIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "FontFile",
    children: /*#__PURE__*/_jsx("path", {
      d: "M27.19 10.55a2 2 0 0 0-.12-.35s0-.07 0-.07c-.06-.11-.14-.21-.22-.3l-7.52-7.5c-.09-.09-.19-.16-.3-.22s-.08 0-.08 0c-.08-.04-.17-.08-.27-.11S9 2 9 2a4.21 4.21 0 0 0-4.21 4.15v20.11C4.79 28.46 6.52 30 9 30h14.03c2.47 0 4.21-1.54 4.21-3.74V10.55h-.03Zm-2.82 15.7c0 .77-.76.97-1.4.97H8.98c-.64 0-1.4-.17-1.4-.97V6.15c0-.77.63-1.4 1.4-1.4h7.95v5.14c0 1.29 1.05 2.34 2.34 2.34h5.11v14.03Zm-7.52-12.51a1 1 0 0 0-.15-.22s-.04-.06-.06-.09-.07-.08-.07-.08a.9.9 0 0 0-.2-.13s-.05 0-.07 0h-.08c-.06-.03-.14-.04-.21-.04s-.15.01-.22.04-.13 0-.13 0c-.09.04-.16.09-.23.15s-.08.06-.08.06c-.02.03-.05.06-.07.09-.05.06-.1.13-.13.2s-3.74 9.36-3.74 9.36a.972.972 0 0 0 .52 1.22c.08.03.18.04.28.04.4 0 .74-.24.89-.58s.89-2.23.89-2.23h3.97l.89 2.22c.18.23.45.37.76.37.54 0 .97-.44.97-.97v-.09l-3.74-9.35v.03Zm-2.09 5.97L16 16.62l1.24 3.09h-2.47Z"
    })
  }));
};